import Seat from '../../../components/Seat';
import WagonTable from '../../../components/WagonTable';
import WagonToilet from '../../../components/WagonToilet';
import WagonBaggage from '../../../components/WagonBaggage';
import WagonDoor from '../../../components/WagonDoor';

function FirstFloor({
  seats,
  chosenSeats,
  setChosenSeats,
  wagonNumber,
  reserveSeat,
  unReserveSeat,
}) {
  return (
    <div>
      <div className="wagon">
        <div className="wagon-floor">
          <h2>I</h2>
        </div>

        <div
          className="seats-row left"
          style={{ width: '755.3px', marginLeft: '80px' }}
        >
          <WagonDoor />
          <WagonToilet />
          {[
            [2, 1],
            [6, 5],
            [10, 9],
            [14, 13],
            [18, 17],
            [22, 21],
            [26, 25],
            [30, 29],
          ]?.map((seatRow) => (
            <div
              className="seat-column"
              key={seatRow[0]}
            >
              <Seat
                seat={seats?.[seatRow[1]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              <Seat
                seat={seats?.[seatRow[0]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                bottom
              />
            </div>
          ))}
          <WagonTable
            style={{ display: 'flex', alignItems: 'center' }}
          />
          {[
            [33, 34],
            [41, 38],
            [45, 42],
            [49, 46],
            [53, 50],
            [57, 54],
            [37, 58],

          ]?.map((seatRow) => (
            <div
              className="seat-column reversed"
              key={seatRow[0]}
            >
              <Seat
                seat={seats?.[seatRow[1]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              <Seat
                seat={seats?.[seatRow[0]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                bottom
              />
            </div>
          ))}
          <WagonBaggage />
          <WagonDoor />
        </div>
        <div
          className="seats-row bottom left"
          style={{ width: '755.3px', marginLeft: '80px' }}
        >
          <WagonDoor />
          <WagonToilet />
          {[
            [4, 3],
            [8, 7],
            [12, 11],
            [16, 15],
            [20, 19],
            [24, 23],
            [28, 27],
            [32, 31],
          ]?.map((seatRow) => (
            <div
              className="seat-column"
              key={seatRow[0]}
            >
              <Seat
                seat={seats?.[seatRow[1]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              <Seat
                seat={seats?.[seatRow[0]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                bottom
              />
            </div>
          ))}
          <WagonTable
            style={{ display: 'flex', alignItems: 'center' }}
          />
          {[
            [35, 36],
            [39, 40],
            [43, 44],
            [47, 48],
            [51, 52],
            [55, 56],
            [59, 60],
            [61, 62],
          ]?.map((seatRow) => (
            <div
              className="seat-column reversed"
              key={seatRow[0]}
            >
              <Seat
                seat={seats?.[seatRow[1]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              <Seat
                seat={seats?.[seatRow[0]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                bottom
              />
            </div>
          ))}
          <WagonDoor />
        </div>
      </div>
    </div>
  );
}

export default FirstFloor;
